// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"publish-header_toggleContainer__1DhVv","toggleText":"publish-header_toggleText__3Vlbl"};